import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import { VideoInterview } from '@recruitee/integrations-http';

import { TeamsApiService } from './teams-api';

export type TeamsHost = { hostId: number; kind: 'host' };
export type TeamsUser = { email: string; hostId: number; avatarUrl: string; name: string };

@Injectable({ providedIn: 'root' })
export class TeamsHttpClient {
  constructor(private teamsApi: TeamsApiService) {}
  public createTeamsMeeting(params: {
    startsAt: string;
    timezone: string;
    duration: number;
    topic: string;
    hostId: number;
  }): Observable<VideoInterview> {
    return this.teamsApi
      .post('meeting', params)
      .pipe(map(({ meeting }: { meeting: VideoInterview }) => meeting));
  }

  public updateTeamsMeeting(
    joinUrl: string,
    params: {
      startsAt: string;
      timezone: string;
      duration: number;
      topic: string;
      hostId: number;
    },
  ): Observable<VideoInterview> {
    return this.teamsApi
      .patch(`meeting?join_url=${encodeURI(joinUrl)}`, params)
      .pipe(map(({ meeting }: { meeting: VideoInterview }) => meeting));
  }

  public getTeamsHosts({ joinUrl }: { joinUrl: string }): Observable<TeamsHost[]> {
    return this.teamsApi.get(`meeting-hosts?join_url=${encodeURI(joinUrl)}`).pipe(
      filterBoolean,
      map(({ hosts }: { hosts: TeamsHost[] }) => hosts),
    );
  }

  public getTeamsUsers(): Observable<TeamsUser[]> {
    return this.teamsApi.get('users').pipe(
      filterBoolean,
      map(({ users }: { users: TeamsUser[] }) => users),
    );
  }
}
